import {
  GET_DEPARTMENTS,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAIL,
  ADD_DEPARTMENT,
  ADD_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

// GET ALL DEPARTMENTS
export const getDepartments = () => ({
  type: GET_DEPARTMENTS,
})
export const getDepartmentsSuccess = departments => ({
  type: GET_DEPARTMENTS_SUCCESS,
  payload: departments,
})
export const getDepartmentsFail = error => ({
  type: GET_DEPARTMENTS_FAIL,
  payload: error,
})
// ADD NEW DEPARTMENT
export const addDepartment = department => ({
  type: ADD_DEPARTMENT,
  payload: department,
})
export const addDepartmentSuccess = department => ({
  type: ADD_DEPARTMENT_SUCCESS,
  payload: department,
})
export const addDepartmentFail = error => ({
  type: ADD_DEPARTMENT_FAIL,
  payload: error,
})
// UPDATE DEPARTMENT
export const updateDepartment = department => ({
  type: UPDATE_DEPARTMENT,
  payload: department,
})
export const updateDepartmentSuccess = department => ({
  type: UPDATE_DEPARTMENT_SUCCESS,
  payload: department,
})
export const updateDepartmentFail = error => ({
  type: UPDATE_DEPARTMENT_FAIL,
  payload: error,
})
// DELETE DEPARTMENT
export const deleteDepartment = department => ({
  type: DELETE_DEPARTMENT,
  payload: department,
})
export const deleteDepartmentSuccess = department => ({
  type: DELETE_DEPARTMENT_SUCCESS,
  payload: department,
})
export const deleteDepartmentFail = error => ({
  type: DELETE_DEPARTMENT_FAIL,
  payload: error,
})
// DISPLAY LOADING ICON
export const showLoading = status => ({
  type: SHOW_LOADING,
  payload: status,
})
export const hideLoading = status => ({
  type: HIDE_LOADING,
  payload: status,
})